import { useDispatch } from 'react-redux';

import { AppDispatch } from 'store';

// typed dispatch needed to get the resolved return value out of AppThunks
export const useAppDispatch = () => useDispatch<AppDispatch>();
